<div class="session-timeout-modal">
	<div class="timeout-icon">
		<i class="pi pi-clock"></i>
	</div>

	<div class="timeout-message">
		<p>Your session is about to expire due to inactivity.</p>
		<p>You will be logged out in:</p>
	</div>

	<div class="countdown" aria-live="polite">
		{{ formattedTime }}
	</div>

	<div class="timeout-actions">
		<button
			pButton
			type="button"
			label="Extend Session"
			class="p-button-primary"
			(click)="onExtendSession()"
		></button>
		<button
			pButton
			type="button"
			label="Log Out"
			class="p-button-secondary p-button-outlined"
			(click)="onLogout()"
		></button>
	</div>
</div>
